(function () {
  var STORAGE_KEY = 'aconverts_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { count: handles.length } })
    );
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return list.indexOf(handle) !== -1;
  }

  function refreshHeartStates() {
    var list = getWishlist();
    document.querySelectorAll('.wishlist-heart[data-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (list.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  // Event delegation so it works on cards added later (infinite scroll, ajax filters, etc.)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wishlist-heart[data-handle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-handle');
    var nowActive = toggleWishlist(handle);

    btn.classList.toggle('is-active', nowActive);
    btn.setAttribute('aria-pressed', nowActive ? 'true' : 'false');
  });

  document.addEventListener('DOMContentLoaded', refreshHeartStates);
  document.addEventListener('wishlist:updated', refreshHeartStates);

  // expose for the wishlist page to use
  window.Wishlist = {
    get: getWishlist,
    isInWishlist: isInWishlist,
    toggle: toggleWishlist,
    remove: function (handle) {
      var list = getWishlist().filter(function (h) {
        return h !== handle;
      });
      saveWishlist(list);
    }
  };
})();